import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../contexts/authContext';
import { TeamTab } from '../../TeamTab';
import { useV2ProposalProjectDetail } from '../useV2ProposalProjectDetail';
import { proposalLoadErrorMessage } from './proposalLoadError';
export function SourcesTeamPage() {
    const { id } = useParams();
    const { user } = useAuth();
    const { projectDetail, isLoading, error } = useV2ProposalProjectDetail(id);
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "p-8 text-sm text-slate-500",
            children: "Loading project..."
        });
    }
    if (error || !projectDetail) {
        return /*#__PURE__*/ _jsx("div", {
            className: "p-8 text-sm text-rose-600",
            children: proposalLoadErrorMessage(error)
        });
    }
    if (!user) {
        return /*#__PURE__*/ _jsx("div", {
            className: "p-8 text-sm text-slate-500",
            children: "Not signed in."
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "p-4 sm:p-6 lg:p-8",
        children: /*#__PURE__*/ _jsx(TeamTab, {
            project: projectDetail,
            currentUserId: user.id
        })
    });
}
